import type { MessageDescriptor } from 'react-intl';
import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { settingsI18n } from '#src/i18nMessages/index.ts';
import { SettingsPageContainer } from '#src/pages/Settings/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/settings_/_layout')({
  component: RouteComponent
});

function RouteComponent() {
  const matches = useMatches();
  const intl = useIntl();

  const lastMatch = matches[4];

  let headingI18n: MessageDescriptor | undefined;
  if (lastMatch.routeId === '/{-$locale}/_auth/settings_/_layout/identities') {
    headingI18n = settingsI18n.childProfiles.heading;
  } else if (lastMatch.routeId === '/{-$locale}/_auth/settings_/_layout/payments') {
    headingI18n = settingsI18n.payments.heading;
  } else if (lastMatch.routeId === '/{-$locale}/_auth/settings_/_layout/personal-info') {
    headingI18n = settingsI18n.personalInfo.heading;
  } else if (lastMatch.routeId === '/{-$locale}/_auth/settings_/_layout/security') {
    headingI18n = settingsI18n.security.heading;
  }

  return (
    <SettingsPageContainer heading={headingI18n ? intl.formatMessage(headingI18n) : undefined}>
      <Outlet />
    </SettingsPageContainer>
  );
}
